module.exports = __webpack_public_path__ + "img/galeria_02.bf77aeda.jpg";